import type { PlanData, TemplateType } from './dealCalculations'

export function getTemplateType(plan: PlanData): TemplateType {
  if (plan.templateType) return plan.templateType

  const name = (plan.nome || '').toLowerCase()
  const id = (plan.id || '').toLowerCase()

  if (name.includes('cro') || id.includes('cro')) return 'cro'
  if (
    name.includes('layout personalizado') ||
    name.includes('e-commerce personalizado') ||
    name.includes('desenvolvimento e-commerce') ||
    id.includes('layout-personalizado')
  ) {
    return 'layout-personalizado'
  }
  if (name.includes('ecommerce') || name.includes('e-commerce') || id.includes('ecommerce') || id.includes('e-commerce')) {
    return 'ecommerce'
  }
  if (name.includes('site institucional') || id.includes('site-institucional')) return 'site-institucional'
  return 'generico'
}
